module.exports = __webpack_public_path__ + "static/img/unpaid-reservation.495d3a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/unpaid-reservation.svg
// module id = B4CE
// module chunks = 0